import { api } from "./core";

// Editor utility API calls that are proxied by the local backend.
export const toolsApi = {
  generateIin() {
    return api("/api/tools/generate-iin");
  },
};
